import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const LastNameInput = () => {
  return <VpHookFormInput maxLength={50} required name="lastName" placeholder="Last Name" />;
};

export default LastNameInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/LastNameInput.jsx